<template functional>
  <div style="align-content: center">
    <template v-if="props.row.boxes_quantity !== null">
      <format-number
        :value="props.row.boxes_quantity"
        :messageLabel="['common_words.quantity', ':', ' ']"
        :strongMessageLabel="true"
        :listClass="``"
      />
    </template>
    <template v-else
      ><strong>
        <translate-text keyTranslate="common_words.quantity" />:
      </strong>
      NA
      <br />
    </template>
    <template v-if="props.row.value !== null">
      <format
        :value="props.row.value"
        :messageLabel="['common_words.value', ':', ' ']"
        :strongMessageLabel="true"
        :listClass="``"
      />
    </template>
    <template v-else
      ><strong> <translate-text keyTranslate="common_words.value" />: </strong>
      NA
      <br />
    </template>
    <strong><translate-text keyTranslate="common_words.reference" />:</strong>
    {{ props.row.box.name }}
  </div>
</template>
<script>
export default {
  name: 'BoxDataFormatter',
};
</script>
